import * as React from 'react';
import * as styles from './styles.css';
import { CSSTransition } from 'react-transition-group';

import { fromBottom } from './transitions';
import { Portal } from './Portal';

interface INotificatorProps {
  isOpen: boolean;
  duration: number | null;
  content?: React.ReactNode;
}

export const Notificator: React.FC<INotificatorProps> = props => {
  const { isOpen, content, duration } = props;
  const nodeRef = React.useRef<HTMLDivElement>(null);

  return (
    <Portal>
      <CSSTransition
        in={isOpen}
        timeout={duration || 1500}
        unmountOnExit
        classNames={fromBottom}
        nodeRef={nodeRef}
      >
        <div ref={nodeRef} className={styles['container']} data-testid="notificator">
          {content}
        </div>
      </CSSTransition>
    </Portal>
  );
};

Notificator.displayName = 'Notificator';
